import React from 'react'

const JS_Essentials_Coding_Pratice_6 = () => {
  return (
    <div>
      <h1>Coding Practice 6</h1>
    </div>
  )
}

export default JS_Essentials_Coding_Pratice_6
